var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.$style.container, _vm.isOpen && _vm.$style.open]},[_c('v-grid')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }